/* eslint import/prefer-default-export: "off" */

const filterUniqueItems = (destination, source, key) => {
  const uniqueItems = [];
  source.forEach(sourceItem => {
    const exists = destination.filter(destinationItem => destinationItem[key] === sourceItem[key]);
    if (!exists.length) {
      uniqueItems.push(sourceItem);
    }
  });
  return uniqueItems;
};

export { filterUniqueItems };



// WEBPACK FOOTER //
// ./src/helpers/unique.js